import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import NavbarMob from "./NavbarMob";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Navbar2 from "./Navbar2";
import { useNavigate } from "react-router-dom";
import Navbar2Mob from "./Navbar2Mob";

function AppliedCan() {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const employeeId = sessionStorage.getItem("employeeId");
    const customerName = sessionStorage.getItem("customerName");
    const [jobDetails, setJobDetails] = useState({});
    const [packageSelections, setPackageSelections] = useState([]);
    const [candidateMap, setCandidateMap] = useState({}); // candidate lookup by phone
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    const customerType = sessionStorage.getItem("customerType");
    const [loading, setLoading] = useState(true);

    // Fetch data from the API
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getPackageSelections/${employeeId}`);
                const result = await response.json();

                if (result.message === "Data retrieved successfully") {
                    // Sort by created_at descending (newest first)
                    const sortedData = result.data.sort((a, b) => {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });

                    setPackageSelections(sortedData);
                    // Wait for all job details to be fetched
                    await Promise.all(sortedData.map((item) => fetchJobDetails(item.jobId)));
                } else {
                    setPackageSelections([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [employeeId]);

    // Fetch candidate master data for enrichment (age, gender, town, location)
    useEffect(() => {
        const fetchCandidates = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getAllCandidates`);
                if (!response.ok) throw new Error("Failed to fetch candidates");
                const candidates = await response.json();

                const normalize = (num) =>
                    (num || "")
                        .replace(/^\+91|\+91|\+/g, "")
                        .replace(/\s/g, "")
                        .replace(/\D/g, "");

                const map = {};
                candidates.forEach((cand) => {
                    [cand.Mobile, cand.WhatsApp].forEach((num) => {
                        const key = normalize(num);
                        if (key) map[key] = cand;
                    });
                });
                setCandidateMap(map);
            } catch (err) {
                console.error("Error fetching candidates:", err);
            }
        };

        fetchCandidates();
    }, [apiBaseUrl]);

    // Function to fetch job details based on jobId
    const fetchJobDetails = async (jobId) => {
        try {
            const response = await fetch(`${apiBaseUrl}/getjobposts/${jobId}`);
            const result = await response.json();
            setJobDetails((prevDetails) => ({ ...prevDetails, [jobId]: result }));
        } catch (error) {
            console.error("Error fetching job details:", error);
        }
    };

    const appliedCandidatesforall = () => {
        navigate("/appliedcanall");
    };

    return (
        <div className="flex flex-col min-h-screen">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>
            <div className="flex lg:px-12 px-3 py-12 flex-col min-h-screen bg-[#eeebeb]">
                {(customerType === "admin" || customerType === "mainAdmin") && (
                    <li
                        className="p-3 bg-gray-100 hover:bg-blue-200 rounded cursor-pointer text-center text-lg font-[400] font-display"
                        onClick={appliedCandidatesforall}
                    >
                        Applied Candidates for Other Jobs
                    </li>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-3">
                    {loading ? (
                        <div className="col-span-full flex justify-center items-center py-20">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#E22E37]"></div>
                        </div>
                    ) : packageSelections.length === 0 ? (
                        <div className="col-span-full text-center py-10 text-gray-500">No applied candidates found.</div>
                    ) : (
                        packageSelections.map((item) => {
                            const jobDetail = jobDetails[item.jobId];

                            const normalize = (num) =>
                                (num || "")
                                    .replace(/^\+91|\+91|\+/g, "")
                                    .replace(/\s/g, "")
                                    .replace(/\D/g, "");
                            const candidate =
                                candidateMap[normalize(item.mobileNumber)] || candidateMap[normalize(item.whatsappNumber)];

                            // Only render if job details are loaded
                            return jobDetail ? (
                                <div key={item.id} className="bg-white rounded-lg shadow-lg p-6 text-left">
                                    <h2 className="text-lg font-bold mb-2 font-display">{item.customerName}</h2>
                                    <p className="text-gray-600 font-display">
                                        <span className="font-[600]">Job ID :</span>
                                        {jobDetail.manualJobID && jobDetail.manualJobID !== "0"
                                            ? jobDetail.manualJobID
                                            : jobDetail.job_id}
                                    </p>
                                    <p className="text-gray-500 font-display">
                                        <span className="font-[600]">Mobile Number :</span> {item.mobileNumber}
                                    </p>
                                    <p className="text-gray-500 font-display">
                                        <span className="font-[600]">Whatsapp Number :</span> {item.whatsappNumber}
                                    </p>
                                    {/* <p className="text-gray-500 font-display">
                                        <span className="font-[600]">Email :</span> {item.Email}
                                    </p> */}
                                    {candidate && (
                                        <>
                                            <p className="text-gray-500 font-display">
                                                <span className="font-[600]">Town :</span> {candidate.bigTown || "N/A"}
                                            </p>
                                        </>
                                    )}
                                    <p className="text-gray-500 font-display">
                                        <span className="font-[600]">Applied On:</span>{" "}
                                        {new Intl.DateTimeFormat("en-IN", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                        }).format(new Date(item.created_at))}
                                    </p>
                                </div>
                            ) : null;
                        })
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default AppliedCan;
